module.exports = __webpack_public_path__ + "img/greyplus.23c7dceb.svg";